module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/icon_tag_more.e5d37.png";